import React from 'react';
import { connect } from 'react-redux';
import Api from "../services/Api";
import { IonButton, IonContent, IonPage, IonRouterLink, IonRow, withIonLifeCycle } from "@ionic/react";
import { formatDate, formatEnd } from "../helpers/format_date"
import { RouteComponentProps } from "react-router";
import { WalkI } from "../interfaces/Walk"
import GoogleMap from "../components/GoogleMap";
import { setView, setTeam } from '../redux/actions/logInActions';
import { getCurrentWalk } from '../redux/actions/talkAction';
import { userState } from '../redux/types/logInTypes';
import ErrorPage from './ErrorPage';

interface ComponentProps extends RouteComponentProps<{
    walkId: string
}> {
  user: userState
  setView: Function
  getCurrentWalk: Function
  openAlert: Function
}

interface ComponentState {
  walk: WalkI;
  loaded: boolean;
  loggedIn: boolean;
  notFound: boolean;
  notAllowed: boolean
}

class ShareWalk extends React.Component<ComponentProps, ComponentState> {

  private api = Api.getInstance();
  private walk: WalkI = {} as any;

  state:Readonly<ComponentState> = {
    loaded: false,
    notFound: false,
    walk: this.walk,
    loggedIn: this.api.loggedIn,
    notAllowed: true
  }

  ionViewWillEnter() {
    this.getData();
  }

  // private getData = () => {
  //   this.api.get('walk/share/' + this.props.match.params.walkId).then(result => {
  //     if (result.ok) {
  //       result.json().then(resultJson => {
  //         console.log(resultJson)
  //         if (resultJson.status === 'ok') {
  //           const walk: WalkI = resultJson.walk;
  //           this.setState({
  //             walk: walk, 
  //             loaded: true
  //           });
  //         }
  //       });
  //     } else {
  //       this.setState({
  //         notFound: true
  //       });
  //       console.log('Not found: ');
  //       console.log(result.status);
  //     }
  //   });
  // }

  private getData = () => {
    this.api.get('walk/share/' + this.props.match.params.walkId).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          if(data.walk.privateWalk && data.walk.availableTo.filter((person: any) => person.id
            )[0].id === this.props.user.person.id) {
              this.setState({
                notAllowed: false
              })
              if(data.walk.teamId === null) {
                this.props.setView('public')
                this.setState({
                  notAllowed: false
                })
              } else {
                this.props.user.teams.forEach(team => {
                  if(team.teamId === data.walk.teamId) {
                    this.props.setView('teams')
                    this.setState({
                      notAllowed: false
                    })
                  }
                })
              }
            } else if(data.walk.privateWalk && data.walk.editable === 1){
              this.setState({
                notAllowed: false
              })
            } else if (!data.walk.privateWalk){
              this.setState({
                notAllowed: false
              })
            } else {
              this.setState({
                notAllowed: true
              })
            }
          const walk: WalkI = data.walk
          this.setState({
            walk: walk, 
            loaded: true
          })

          this.props.getCurrentWalk(data.walk)
        } else {
          this.setState({
            notFound: true,
            loaded: true
          })
        }
      }).catch(e => {        
        this.setState({
          notFound: true,
          loaded: true,
        })
      })
    })
  }


  render() {

    let bookText: string;
    let bookLink: string;
    if (this.state.walk.walkType === 'done') {
      bookText = 'Hoppsan - försent! Hitta en ny...';
      bookLink = '/walk/home';
    } else if (this.state.walk.booked === 0) {
      bookText = 'Gå till promenaden';
      bookLink = '/walk/walk/' + this.props.match.params.walkId;
    } else {
      bookText = 'Bokad. Hitta ny promenad';
      bookLink = '/walk/home';
    }

    if (this.state.notFound) {
      return (
        <IonPage className="cheap_desktop">
          <IonContent>
            <div className="mx-4 mt-16">
              <h1>Hittade inte promenaden</h1>
              <IonRouterLink routerLink="/walk/home">
                <IonButton className="mt-8" expand="block">
                  Börja om
                </IonButton>
              </IonRouterLink>
            </div>
          </IonContent>
        </IonPage>
      )
    }

    return (
      <IonPage className="cheap_desktop">
        { this.state.notAllowed ? 
          <ErrorPage/>
          : 
          <IonContent>
            <div className="cheap_desktop">
            { this.state.walk.hasCoordinates ? 
              <div style={{height: "40vh", position: "relative"}}>
                {
                  this.state.loaded &&
                  <GoogleMap 
                    lat={this.state.walk.lat} 
                    lng={this.state.walk.lng} 
                    zoom={this.state.walk.zoom}
                    placeName={this.state.walk.placeName} 
                    fixedMarker={false} 
                    height={50}/>
                }
              </div> : 
              <IonRow class="background_teal p-4 flex justify-center items-center">
                <h2>Audiopromenad</h2>
              </IonRow> }

              <div style={{position: "relative", backgroundColor: "#fff"}} className="walk_card px-4">
                <h1 className="pt-4">{this.state.walk.name}</h1>

                <p className="mt-4 gray_medium">{formatDate(this.state.walk.start)}-{formatEnd(this.state.walk.start, this.state.walk.lengthMinutes)}</p>

                <IonRouterLink routerLink={bookLink}>
                  <IonButton className="mt-8 uppercase" expand="block">
                    {bookText}
                  </IonButton>
                </IonRouterLink>

                <div className="mt-8 flex items-center justify-between">
                  <div style={{width: "40px"}}>
                    <img className="circle_picture" alt="profil" src={this.state.walk.personPicture}/>
                  </div>
                  <div className="mx-2 flex-1">
                    <p>{this.state.walk.personName}</p>
                  </div>
                </div>
                <p className="py-4 gray_medium">
                  {this.state.walk.description}
                </p>
              </div>
            </div>
          </IonContent>
        }
      </IonPage>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.logIn.user
  }
}

const mapDispatchToProps = {
  setView,
  setTeam,
  getCurrentWalk
}

export default connect(mapStateToProps, mapDispatchToProps)(withIonLifeCycle(ShareWalk));
